import type { arrayOfFilters, MultiSelectItem } from '@/types/types'

export function findFilterValueElementInsideDynamicFilters(
  currentFilters: arrayOfFilters,
  generalFilterLabel: string,
  name: string
): MultiSelectItem | undefined {
  const searchedGeneralFilterForCheckboxState = currentFilters?.find((generalFilterItem) => {
    return generalFilterItem.options.label.toLowerCase() === generalFilterLabel.toLowerCase()
  })

  if (searchedGeneralFilterForCheckboxState?.options.values) {
    return searchedGeneralFilterForCheckboxState.options.values.find((elemOfGeneralFilter) => {
      return elemOfGeneralFilter.name === name
    })
  }

  return undefined
}